import APP_ROUTES_CONSTANT from 'constants/appRouteConstants';
import { fetchLoanDetails } from 'containers/OnBoardingFlow/Waitlist/Services';
import { fetchLenderUpgradeDetails } from 'containers/PostPaidFlow/LenderUpgrade/Services';
import ChangeHistory from './ChangeHistory';
import { isSuperAppHome } from './isSuperAppHome';
import { getAppVersion } from './appUpdateHelper';
import { globalConstant } from 'constants';
import GLOBAL_CONSTANT from 'constants/globalConstant';
import { getURLParameter } from './getURLParameter';
import isIOS from './iOSDetector';

export const homeDetailsUtil = async (HomeData, featureAccessData) => {
	const appVersion =
		getAppVersion() ||
		parseInt(getURLParameter(globalConstant.URL_PARAMETER.APPVERSION).toString().split('.').join('')?.trim());
	const isAppVersionEligibleforMigration = () => {
		if (isIOS) return appVersion >= 124;
		return appVersion >= 147;
	};

	const lenderLimitDetails =
		HomeData?.accountStatus === 'ACTIVE' || HomeData?.accountStatus === 'BLOCKED'
			? await fetchLenderUpgradeDetails()
			: {};
	const dsaLoanDetails = await fetchLoanDetails();
	const isOnboardingEnabled = featureAccessData?.onboardingEnabled;

	let apiData = HomeData;
	if (apiData?.eligibleForSuperAppMigration && isAppVersionEligibleforMigration) {
		return ChangeHistory('push', '/super-app-migration-ll');
	}
	if (isSuperAppHome()) return;
	switch (apiData?.accountStatus) {
		// case 'NA':
		// 	apiData['baseRoute'] = isOnboardingEnabled ? '/onboarding/enter-pan' : APP_ROUTES_CONSTANT.onboarding.upgrade;
		// 	break;
		// case 'INIT':
		// 	if (isOnboardingEnabled) {
		// 		if (apiData?.accountType === 'RECEIVED_LIMIT') {
		// 			apiData['baseRoute'] = '/received-limit/home';
		// 		} else {
		// 			apiData['baseRoute'] = 'kyc';
		// 		}
		// 		break;
		// 	}

		// 	apiData['baseRoute'] = APP_ROUTES_CONSTANT.onboarding.upgrade;
		// 	break;

		case 'INACTIVE':
			if (apiData?.accountType === 'RECEIVED_LIMIT') {
				apiData['baseRoute'] = '/received-limit/home';
			} else {
				apiData['baseRoute'] = '/onboarding/agreement';
			}
			break;
		case 'CONTACT_REFERENCES_PENDING':
			apiData['baseRoute'] = '/onboarding/add-reference';
			break;
		case 'LENDER_APPROVAL_PENDING':
		case 'AGREEMENT_PENDING':
			//for LENDER_APPROVAL_PENDING case :
			// apiData['baseRoute'] = '/onboarding/annual-income';
			// break;
			// if (apiData?.userDataDto?.emailVerified == false)
			// 	apiData['baseRoute'] = '/onboarding/additional-details-email';
			// else if (apiData?.userDataDto?.isAddressSaved == false)
			// 	apiData['baseRoute'] = '/onboarding/additional-details-address';
			// else apiData['baseRoute'] = '/onboarding/agreement';
			apiData['baseRoute'] = '/onboarding/upgrade'; //redo
			break;
		case 'LENDER_REJECTED':
			apiData['baseRoute'] = '/onboarding/lender-process';
			break;
		case 'CLOSED':
			if (apiData?.postPaidAccount?.lender === 'ARC') {
				apiData['baseRoute'] = '/arcUsers';
				break;
			}
			apiData['baseRoute'] = '/closed';
			break;
		case 'ACTIVE':
		case 'BLOCKED':
		case 'PERMANENT_BLOCKED':
			if (apiData?.accountType === 'POSTPAID' && apiData?.postPaidAccount) {
				apiData['baseRoute'] = apiData['baseRoute'] || APP_ROUTES_CONSTANT.postpaid.home;
				apiData = { ...apiData, ...apiData?.postPaidAccount };
			} else if (apiData?.accountType === 'PREPAID' && apiData?.prePaidAccount) {
				apiData['baseRoute'] =
					apiData?.kycLevel !== 2 ? 'kyc' : apiData?.prePaidAccount ? '/prepaid/home' : '/prepaid/agreement';
				apiData = { ...apiData, ...apiData?.prePaidAccount };
			} else {
				apiData['baseRoute'] = APP_ROUTES_CONSTANT.somethingWrong;
			}
			break;

		case 'INELIGIBLE':
		case 'WAITLIST':
			if (apiData?.accountType === 'RECEIVED_LIMIT') {
				apiData['baseRoute'] = '/received-limit/home';
			} else {
				apiData['baseRoute'] = isOnboardingEnabled
					? dsaLoanDetails?.data && dsaLoanDetails?.data?.is_pre_validated === false && apiData?.kycLevel === 2
						? '/onboarding/check-loan-eligibility'
						: '/onboarding/waitlist'
					: APP_ROUTES_CONSTANT.onboarding.upgrade;
			}
			break;

		default:
			break;
	}
	if (lenderLimitDetails && lenderLimitDetails?.data?.lenderUpgrade) {
		apiData['baseRoute'] = '/onboarding/upgrade-screen'; //redo
	}
	ChangeHistory('push', apiData['baseRoute']);
};
